export default __webpack_public_path__ + "static/media/visita_v.acbb3b8c.png";